module.exports = __webpack_public_path__ + "static/img/equipment5new.842c6aa8.png";